import types from '../types/index';

/** Кеш тримає лише кілька останніх місяців — довше за сесію він не потрібен. */
const MONTH_CACHE_LIMIT = 6;

const evictOldMonths = (cache) => {
  const keys = Object.keys(cache);
  if (keys.length <= MONTH_CACHE_LIMIT) return cache;

  return keys
    .sort((a, b) => cache[b].at - cache[a].at)
    .slice(0, MONTH_CACHE_LIMIT)
    .reduce((acc, key) => ({ ...acc, [key]: cache[key] }), {});
};

const initialState = {
  // місяць
  month: [],
  monthKey: null,
  monthCache: {},
  monthLoading: false,
  monthError: '',

  // вибраний день
  day: [],
  dayKey: null,
  dayLoading: false,
  dayError: '',
};

/**
 * Відповідь застаріла, якщо користувач уже перемкнувся на інший місяць/день.
 * Без цієї перевірки повільніший запит перезаписував свіжіший — у панелі опинявся чужий день.
 */
const isStale = (payloadKey, currentKey) => payloadKey !== currentKey;

const reducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case types.schedule.START_FETCHING_MONTH:
      return { ...state, monthKey: payload, monthLoading: true, monthError: '' };

    case types.schedule.GET_MONTH_SCHEDULE: {
      if (isStale(payload.monthKey, state.monthKey)) return state;

      return {
        ...state,
        month: payload.events,
        monthCache: evictOldMonths({
          ...state.monthCache,
          [payload.monthKey]: { events: payload.events, at: Date.now() },
        }),
      };
    }

    case types.schedule.GET_MONTH_SCHEDULE_ERROR:
      if (isStale(payload.monthKey, state.monthKey)) return state;
      return { ...state, month: [], monthError: payload.message };

    case types.schedule.STOP_FETCHING_MONTH:
      if (isStale(payload, state.monthKey)) return state;
      return { ...state, monthLoading: false };

    case types.schedule.START_FETCHING_DAY:
      return { ...state, dayKey: payload, dayLoading: true, dayError: '', day: [] };

    case types.schedule.GET_DAY_EVENT:
      if (isStale(payload.dayKey, state.dayKey)) return state;
      return { ...state, day: payload.events };

    case types.schedule.GET_DAY_EVENT_ERROR:
      if (isStale(payload.dayKey, state.dayKey)) return state;
      return { ...state, day: [], dayError: payload.message };

    case types.schedule.STOP_FETCHING_DAY:
      if (isStale(payload, state.dayKey)) return state;
      return { ...state, dayLoading: false };

    case types.schedule.RESET_SCHEDULE:
      return initialState;

    default:
      return state;
  }
};

export default reducer;
